import React from "react";
import { FadeUp } from "./Reveal";

const shots = [
    { src: "https://images.unsplash.com/photo-1617191880362-aac615de3c26?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Kundan kadas", cls: "md:col-span-2 h-64 md:h-80" },
    { src: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Diamond solitaire", cls: "md:col-span-3 h-64 md:h-96" },
    { src: "https://images.unsplash.com/photo-1600685890506-593fdf55949b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Bridal legacy", cls: "md:col-span-4 h-64 md:h-80" },
    { src: "https://images.unsplash.com/photo-1611107683227-e9060eccd846?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Gold chains", cls: "md:col-span-3 h-64 md:h-96" },
    { src: "https://images.unsplash.com/photo-1728381031272-ba3f537feadd?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Ruby bangles", cls: "md:col-span-5 h-64 md:h-72" },
    { src: "https://images.unsplash.com/photo-1599071338288-49173359e0fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Craftsmanship", cls: "md:col-span-4 h-64 md:h-72" },
    { src: "https://images.unsplash.com/photo-1724937721228-f7bf3df2a4d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Diamond pendant", cls: "md:col-span-3 h-64 md:h-72" },
];

export default function Gallery() {
    return (
        <section id="gallery" data-testid="gallery-section" className="py-24 sm:py-32">
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <FadeUp>
                    <p className="eyebrow">Gallery</p>
                    <h2 className="font-display font-light text-3xl sm:text-4xl lg:text-5xl mt-4 mb-14">
                        A glimpse — <span className="italic text-gold-gradient">of our shop's sparkle.</span>
                    </h2>
                </FadeUp>
                <div className="grid grid-cols-2 md:grid-cols-12 gap-3 sm:gap-4">
                    {shots.map((s, i) => (
                        <FadeUp key={s.src} delay={i * 0.06} className={`${i < 4 ? "col-span-1 md:col-span-" + s.cls.match(/col-span-(\d)/)[1] : ""} ${i >= 4 ? "md:col-span-" + s.cls.match(/md:col-span-(\d)/)[1] : ""}`}>
                            <div className={`img-zoom relative overflow-hidden border border-gold/15 hover:border-gold/45 transition-colors duration-500 w-full ${s.cls}`}>
                                <img src={s.src} alt={s.caption} loading="lazy" className="w-full h-full object-cover" />
                                <div className="absolute inset-0 bg-obsidian/30 group-hover:bg-transparent" />
                                <p className="absolute bottom-3 left-4 text-[11px] uppercase tracking-[0.25em] text-gold-light/90">
                                    {s.caption}
                                </p>
                            </div>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </section>
    );
}
